export {default} from "./Loader";
